import {
  Vector3,
  Vector2,
  Object3D,
  AmbientLight,
  PerspectiveCamera,
  OrthographicCamera,
  CameraHelper,
  DirectionalLight,
  Math as TMath,
  BoxBufferGeometry,
  PointLight,
  PlaneGeometry,
  Scene,
  Mesh,
  Line,
  MeshLambertMaterial,
  Color,
  Raycaster,
  WebGL1Renderer,
  MeshBasicMaterial,
  DoubleSide,
  GridHelper,
  FaceColors,
  TextureLoader,
  RawShaderMaterial,
  BufferAttribute,
  BufferGeometry,
  PlaneBufferGeometry,
  MOUSE,
  TOUCH,
  LineBasicMaterial,
  Geometry,
  Face3,
  HemisphereLight,
  MeshStandardMaterial,
  Box3, FrontSide,
  ArrowHelper,
  Quaternion,
  WireframeGeometry,
  LineSegments,
  BackSide,
  Group
} from 'three';

import { BufferGeometryUtils } from 'three/examples/jsm/utils/BufferGeometryUtils.js';
// import Stats from 'stats.js';
import URLSearchParams from '@ungap/url-search-params';
import Delaunator from 'delaunator';

const loadFont = require("load-bmfont");
const MSDFShader2D = require("three-bmfont-text/shaders/msdf");
const createGeometry = require("@srinivasprabhu/three-bmfont-text");
const MSDFShader3D = require("@srinivasprabhu/three-bmfont-text/shaders/msdf");
import * as jsPDF from "jspdf";
import {OrbitControls} from "three/examples/jsm/controls/OrbitControls";

import * as THREE from 'three';
import CameraControls from 'camera-controls';
const clock = new THREE.Clock();

CameraControls.install( { THREE: THREE } );

const colorsFromPalette = require("nice-color-palettes");
const palette = colorsFromPalette[4];
let currentDimension = "3d";
let rendererCanvas = null;
let rootScene = null;
let rootTextTexture = null;
let propileDrawingApp = null;
let reqAnimFrameId = null;

class PropileDrawingApp{
  constructor(loadedFont, loadedTexture, textMaterial2D, textMaterial3D) {

    let camera, scene, raycaster, controls, hemilight;

    let renderer;
    let oldCanvas = document.getElementById('pileMap');
    if(oldCanvas) {
      renderer = new WebGL1Renderer({ canvas: oldCanvas, preserveDrawingBuffer: true, antialias:true, logarithmicDepthBuffer: true });
    }
    else {
      renderer = new WebGL1Renderer({ preserveDrawingBuffer: true, antialias:true, logarithmicDepthBuffer: true });
    }

    rendererCanvas = renderer;


    // These should default in AJAX, unless they are set from GET-parameters
    let initialZoom = 0.5;
    let initialPosition = new Vector3();

    // Set these with AJAX
    let initialRotation = 0;
    let initialInversionX = 0;
    let initialInversionY = 0;
    let initialGridX = 0;
    let initialGridY = 0;

    let firstInit = true;

    // let yellow = 0xF2C57C;
    let red = 0xFF959C;
    let orange = 0xFF8C61;
    let green = 0x94E480;
    let blue = 0x66C7F4;
    let darkGray = 0x3d3d3d;
    let gray = 0xE1DED5;
    let yellow = 0xFFE74C

    let maxX = 0;
    let maxY = 0;
    let maxXY = 0;
    let highestPile = 0;
    let oldProjectBearing = 0;
    let newProjectBearing = 0;

    let pileDistance = 50;
    let gridSize = 0; //40

    let jsonObjects;
    let objects2d;
    let objects3d;
    let prevObj;

    let labels;
    let textLabelBufferGeometries;
    let textLabelsFor2D;
    let textLabelsFor3D

    let mouse = new Vector2(), INTERSECTED;

    let cameraPosition;
    let cameraRotation = new Vector3(0, 0, 0);

    let cameraDeltaVector;


    let togglePopup = false;
    let hidePopup = false;
    let previousMousePos = { x: 0, y: 0 };

    let orthoZoom = 0.5;

    let labelType = 'PileID';
    let filterType1 = 'none';
    let filterType2 = 'none';
    let labelFontSize = 1;

    let gridX = 0;
    let gridY = 0;

    let gridRotY = 0;
    let gridGroup = null;

    let rotateDelta = 0;
    let defaultRotateTime = 500;
    let rotateTime = defaultRotateTime;
    let rotateTimer;
    let rotateBool = false;

    let moveGridDelta = 0;
    let defaultMoveGridTime = 100;
    let moveGridTime = defaultMoveGridTime;
    let moveGridTimer;
    let moveGridBool = false;
    let moveGridDirection = 0;
    let GRID_DIRECTION = { X: 1, Y: 2 };

    let transparentPlane;

    let oldData = {};
    let updateTimer;

    // let stats = new Stats();
    // stats.showPanel( 0 ); // 0: fps, 1: ms, 2: mb, 3+: custom
    // document.body.appendChild( stats.dom );
    let filterColors = {
      none: gray,
      Broken: red,
      RST: blue,
      Ctrl_str: yellow,
      PDA: orange
    }

    let type;

    let dimensions = {
      '2d': {
        camera: function () { return new OrthographicCamera(-window.innerWidth/2, window.innerWidth/2, window.innerHeight/2, -window.innerHeight/2, 0.1, 1000 ) },
        light: function () {
          let light = new DirectionalLight( 0xffffff, 1 );
          scene.add(light);
        },
        controls: function (json) {
          camera.up.set(0,0,1);
          controls = new CameraControls(camera, renderer.domElement);
          controls.mouseButtons.left = controls.mouseButtons.right;
          controls.minPolarAngle = 2* Math.PI;
          controls.maxPolarAngle = 0.0;
          if(json.x == 0 && json.y == 0){

            let initX = ((((maxX/ 2) * (pileDistance/ 2)) * Math.sin( TMath.degToRad( 0.2 ) )) + ((maxX / 2) * pileDistance) - (25 * pileDistance) );
            let initY = ((((maxY/ 2) * (pileDistance/ 2)) * Math.sin( TMath.degToRad( 0.2 ) )) + ((maxY / 2) * pileDistance) - (25 * pileDistance) );
            controls.setTarget(-initX, -initY, 0.0);
          }else{
            controls.setTarget(parseFloat(json.x), parseFloat(json.y), 0.0);
        }
        },
        initCameraPosition: function (json) {
          if(json.x == 0 && json.y == 0){

            let initX = ((((maxX/ 2) * (pileDistance/ 2)) * Math.sin( TMath.degToRad( 0.2 ) )) + ((maxX / 2) * pileDistance) - (25 * pileDistance) );
            let initY = ((((maxY/ 2) * (pileDistance/ 2)) * Math.sin( TMath.degToRad( 0.2 ) )) + ((maxY / 2) * pileDistance) - (25 * pileDistance) );
            cameraPosition = new Vector3(-initX, -initY, -550);

            camera.position.x = cameraPosition.x;
            camera.position.y = cameraPosition.y;
            camera.position.z = cameraPosition.z;
            camera.zoom = json.zoom;
            camera.updateProjectionMatrix();
          }else{

            cameraPosition = new Vector3(parseFloat(json.x), parseFloat(json.y), -550);

            camera.position.x = cameraPosition.x;
            camera.position.y = cameraPosition.y;
            camera.position.z = cameraPosition.z;
            camera.zoom = json.zoom;
            camera.updateProjectionMatrix();
          }

        },
        pileColor: function(rigID) { return rigID > 0 ? green : gray },
        boxSize: function() { return new BoxBufferGeometry( 20, 20, 20 ); },
      },
      '3d': {
        camera: function () {
          let camera = new PerspectiveCamera(75, window.innerWidth/window.innerHeight, 0.0001, 10000 );
          camera.up.set(0,0,-1);
          return camera;
        },
        light: function () {
          //Add dir light.
          let dirLight = new DirectionalLight(0xffffff, 0.8);
          dirLight.position.set(-1000,-5000,-10000);
          scene.add(dirLight);
          scene.add(new AmbientLight(0xffffff, 0.5));
        },
        controls: function (json) {
          controls = new OrbitControls(camera, renderer.domElement);
          controls.screenSpacePanning = true;
          controls.mouseButtons.LEFT = MOUSE.ROTATE;
          controls.mouseButtons.RIGHT = MOUSE.PAN;
          controls.touches.ONE = TOUCH.PAN;
          controls.touches.TWO = TOUCH.DOLLY_ROTATE;
          controls.enableRotate = true;
          controls.enablePan = true;
          controls.enableZoom = true;
          controls.update();
          return controls;
        },
        initCameraPosition: function (json) {
          cameraPosition = new Vector3(0.0,0.0,0.0);
        },
        pileColor: function(pile)
        {
          let topPos = new Vector3(pile.x_col, pile.y_col, parseFloat(pile.z_col));
          let toePos = new Vector3(pile.x_toe, pile.y_toe, parseFloat(pile.z_toe));

          topPos.multiplyScalar(pileDistance).negate();
          toePos.multiplyScalar(pileDistance).negate();

          if(pile.RigID > 0) {
            return green;
          }
          else {
            if(topPos.distanceTo(toePos) > 0.0) { //KranId=0 but still has a length and used for triangulation
              return darkGray;
            }
            else {
              return gray;
            }
          }
        },
        boxSize: function() { return new BoxBufferGeometry( 20, 20, 1 ); }
      }
    }

    scene = new Scene();
    rootScene = scene;
    scene.background = new Color( 0xfefefe/* 0x00caff */ );
    let dim = null;


    if (document.querySelector("#pile-type-btg-or-steel")) {
      $('#change_PID_dialog').on('dialogclose', function(event, ui) {
        firstInit = true;
      });
    }

    let getPiles = function () {
      let url = new URLSearchParams(window.location.search);

      if (document.querySelector("#pile-type-btg-or-steel")) {
        if (type!== undefined && document.querySelector("#pile-type-btg-or-steel").value !== type.toLowerCase()) {
          firstInit = true;
        }

        type = document.querySelector("#pile-type-btg-or-steel").value;
        type = type.charAt(0).toUpperCase() + type.slice(1);
      } else {
        type = url.get('type');
      }

      let parameters = {
        projectID: url.get('PROJEKT_ID'),
        type: type,
        userID: url.get('USER_ID'),
      };
      $(".loading-pilemap").show();
      jQuery.getJSON("getPileInfo.php", parameters , function(json) {
        jsonObjects = json.piles;
        maxX = json.maxX + 50;
        maxY = json.maxY + 50;

        if(!json.Enable_3d){
          $('.toggleDrawingBtg').attr('disabled',true);
          $('.toggleDrawingBtg').addClass('ui-state-disabled');
          $('.toggleDrawingSteel').attr('disabled',true);
          $('.toggleDrawingSteel').addClass('ui-state-disabled');
        }else{
          $('.toggleDrawingBtg').attr('disabled',false);
          $('.toggleDrawingBtg').removeClass('ui-state-disabled');
          $('.toggleDrawingSteel').attr('disabled',false);
          $('.toggleDrawingSteel').removeClass('ui-state-disabled');
        }

        $('.error-popup-container').css('display','none');
        dim = dimensions[currentDimension];
        setUpDimension(dim, json);

        if (json.weird_data) {
          $(".loading-pilemap").hide();
          $('.error-popup-container-message').html("Det finns p&aring;lar med potentiellt felaktiga koordinater. V&auml;nligen kontrollera/justera koordinaterna p&aring; p&aring;larna.");
          $('.error-popup-container').removeClass('hidden');
          $('.error-popup-container').css('display','');

          $('.error-popup-container-close-btn').on('click', function() {
            $('.error-popup-container').addClass('hidden');
            $('.error-popup-container').css('display','none');
          })
        } else if (jsonObjects.length === 0){
          $(".loading-pilemap").hide();
          $('.error-popup-container-message').html("Ritningen kan inte visas d&aring; projektet saknar p&aring;lar med angivna koordinater.");
          $('.error-popup-container').removeClass('hidden');
          $('.error-popup-container').css('display','');

          $('.error-popup-container-close-btn').on('click', function() {
            $('.error-popup-container').addClass('hidden');
            $('.error-popup-container').css('display','none');
          })
        }

        maxXY = Math.max(maxX, maxY) ;
        gridSize = Math.ceil(maxXY / 25 );
        maxXY = Math.ceil(maxXY / 50) * 50 * pileDistance;
        highestPile = json.highestPile;
        newProjectBearing = json.project_bearing;
        oldProjectBearing = newProjectBearing;
        initialRotation = parseInt(json.rotation) || 0;
        initialZoom = parseFloat(json.zoom) || 0.5;
        initialPosition.x = parseInt(json.x) || 0;
        initialPosition.z = parseInt(json.z) || 0;
        initialPosition.y = parseInt(json.y) || 0;
        labelType = json.label || 'PileID';
        filterType1 = json.filter1 || 'none';
        filterType2 = json.filter2 || 'none';
        gridRotY = initialRotation;

        let iType = '';
        if (type !== 'btg_mobile' && type !== 'btg_steel') {
          iType = type;
        }

        $(`input[name="pileMapLabel${iType}"][value="${labelType}"]`).prop('checked', true);
        $(`input[name="pileMapFilter1${iType}"][value="${filterType1}"]`).prop('checked', true);
        $(`input[name="pileMapFilter2${iType}"][value="${filterType2}"]`).prop('checked', true);

        initialInversionX = json.inversion_x;
        initialInversionY = json.inversion_y;
        initialGridX = json.grid_x;
        initialGridY = json.grid_y;

        if (+initialGridX == 0) {
          initialGridX = (((maxX/ 2) * (pileDistance/ 2)  ) * Math.sin( TMath.degToRad( 0.2 ) )) + ((maxX / 2) * pileDistance) - (25 * pileDistance);
        }
        if (+initialGridY == 0) {
          initialGridY = (((maxY/ 2) * (pileDistance/ 2)  ) * Math.sin( TMath.degToRad( 0.2 ) )) + ((maxY / 2) * pileDistance) - (25 * pileDistance);
        }

        cameraPosition.x = (((maxX/ 2) * (pileDistance/ 2)) * Math.sin( TMath.degToRad( 0.2 ) )) + ((maxX / 2) * pileDistance) - (25 * pileDistance);
        cameraPosition.y = (((maxY/ 2) * (pileDistance/ 2)) * Math.sin( TMath.degToRad( 0.2 ) )) + ((maxY / 2) * pileDistance) - (25 * pileDistance);


        $(".loading-pilemap").hide();
        if (!json.weird_data) {
          init();
          updateProject();
          animate();
        }

      });
    }

    getPiles();

    if(typeof $('#subtabs_btg').tabs === 'function') {
      $('#subtabs_btg').tabs({
        activate: function(event, ui) {
          if((ui.newTab.context.hash) === '#tab_plotPalRitning_btg'){ getPiles(); }
        }
      });
    }
    if(typeof $('#subtabs_steel').tabs === 'function') {
      $('#subtabs_steel').tabs({
        activate: function(event, ui) {
          if((ui.newTab.context.hash) === '#tab_plotPalRitning_steel'){ getPiles(); }
        }
      });
    }

    function setUpDimension(dim, json){
      camera = dim.camera();
      dim.initCameraPosition(json);
      dim.light();
      dim.controls(json);
    }

    function init() {
      oldData = {
        rotation: cameraRotation.z,
        zoom: orthoZoom,
        x: cameraPosition.x,
        y: cameraPosition.y,
        z: cameraPosition.z,
        gridX: gridX,
        gridY: gridY,
      };

      raycaster = new Raycaster();

      if (document.querySelector("#pile-type-btg-or-steel")) {
        type = document.querySelector("#pile-type-btg-or-steel").value;
        type = type.charAt(0).toUpperCase() + type.slice(1);
      } else {
        type = "";
      }


      if ($(".pileMapContainer" + type)) {
        renderer.setPixelRatio( window.devicePixelRatio );
        if ($(".pileMapContainer" + type).offset().top != undefined) {
          renderer.setSize( $(".pileMapContainer" + type).width(), window.innerHeight - ( $(".pileMapContainer" + type).offset().top + 10));
        }else{
          renderer.setSize( $(".pileMapContainer" + type).width(), window.innerHeight -  10);
        }
      }


      if (oldCanvas !== null) {
        if ( firstInit ) { clearEvents(); }

        let oldCanvasID = oldCanvas.id;
        document.querySelector("#" + oldCanvasID).parentNode.removeChild(oldCanvas);
      }


      let pileMapContainer = document.querySelector(".pileMapContainer" + type);
      let pileMap = document.getElementById("pileMap");
      if(!pileMapContainer.contains(pileMap)) {
        oldCanvas = document.querySelector(".pileMapContainer" + type).appendChild(renderer.domElement);
        oldCanvas.id = "pileMap";
        oldCanvas.tabIndex = -1;
        oldCanvas.classList.add('disablePanZoom');
      }

      if ( firstInit ) {
        firstInit = false;
        cameraRotation.z = initialRotation;
        gridX = initialGridX;
        gridY = initialGridY;


        document.querySelector(".pileMapContainer" + type + ' #rotation').innerText = cameraRotation.z;

        initializeEvents();

        document.querySelector(".pileMapContainer" + type).addEventListener( 'mousemove', onDocumentMouseMove, false );

        //window.addEventListener( 'resize', onWindowResize, false );
      }

      makeObjects();
    }

    function toggleGrids() {
      if(gridGroup && gridGroup.length > 2) {
        //Toggle grids except the topmost and bottom most grids.
        for(let i=1; i < gridGroup.children.length - 1; ++i) {
          gridGroup.children[i].visible = !gridGroup.children[i].visible;
        }
      }
    }

    function makeObjects() {
      labels = [];
      textLabelBufferGeometries = [];

      function buildBox2D(subdivisions=2) {
        const geometry = new Geometry();
        let height = 20.0;

        let maxIndex = 0;
        let numFaces = 2;
        let depthFightCoefficient = 0.0;

        for(let i=1; i<=subdivisions;++i){

          if(i===1){
            geometry.vertices.push(new Vector3(0 - height/2, 0 - height/2, 0));
            geometry.vertices.push(new Vector3(0 - height/2, 0 + height/2, 0));
            geometry.vertices.push(new Vector3(0 + height/2, 0 + height/2, 0));
            geometry.vertices.push(new Vector3(0 + height/2, 0 - height/2, 0));
          }
          else {
            geometry.vertices.push(new Vector3(0 - (height/(2*i)), 0 - (height/(2*i)) + depthFightCoefficient, 0 + depthFightCoefficient));
            geometry.vertices.push(new Vector3(0 - (height/(2*i)), 0 + (height/(2*i)) + depthFightCoefficient, 0 + depthFightCoefficient));
            geometry.vertices.push(new Vector3(0 + (height/(2*i)), 0 + (height/(2*i)) + depthFightCoefficient, 0 + depthFightCoefficient));
            geometry.vertices.push(new Vector3(0 + (height/(2*i)), 0 - (height/(2*i)) + depthFightCoefficient, 0 + depthFightCoefficient));
          }


          geometry.faces.push(new Face3(maxIndex+0, maxIndex+1, maxIndex+2, new Vector3(0.0,0.0,1.0) ));
          geometry.faces.push(new Face3(maxIndex+0, maxIndex+2, maxIndex+3, new Vector3(0.0,0.0,1.0)));

          maxIndex += 4;

          //Set colors to above faces
          let color = new Color(green);
          for(let j=(i-1)*numFaces; j < numFaces*i; j++) {
            geometry.faces[j].color = color;
          }
        }

        geometry.computeFaceNormals();
        geometry.computeVertexNormals();
        geometry.colorsNeedUpdate = true;

        return geometry;
      }

      function buildBox3D(from, to) {
        const geometry = new Geometry();
        let height = 20.0;

        geometry.vertices.push(new Vector3(from.x - height/2, from.y - height/2, from.z));
        geometry.vertices.push(new Vector3(from.x - height/2, from.y + height/2, from.z));
        geometry.vertices.push(new Vector3(from.x + height/2, from.y + height/2, from.z));
        geometry.vertices.push(new Vector3(from.x + height/2, from.y - height/2, from.z));

        geometry.vertices.push(new Vector3(to.x - height/2, to.y - height/2, to.z));
        geometry.vertices.push(new Vector3(to.x - height/2, to.y + height/2, to.z));
        geometry.vertices.push(new Vector3(to.x + height/2, to.y + height/2, to.z));
        geometry.vertices.push(new Vector3(to.x + height/2, to.y - height/2, to.z));



        geometry.faces.push(new Face3(0, 1, 2 )); //Front face
        geometry.faces.push(new Face3(0, 2, 3 ));

        geometry.faces.push(new Face3(7, 6, 5 )); //Back face
        geometry.faces.push(new Face3(7, 5, 4 ));

        geometry.faces.push(new Face3(4, 5, 1 )); //Left face
        geometry.faces.push(new Face3(4, 1, 0 ));

        geometry.faces.push(new Face3(3, 2, 6 )); //Right face
        geometry.faces.push(new Face3(3, 6, 7 ));

        geometry.faces.push(new Face3(1, 5, 6 )); //Up face
        geometry.faces.push(new Face3(1, 6, 2 ));

        geometry.faces.push(new Face3(4, 0, 3 )); //Down face
        geometry.faces.push(new Face3(4, 3, 7 ));

        geometry.computeFaceNormals();
        geometry.computeVertexNormals();

        return geometry;
      }

      let material = new MeshBasicMaterial({
        color: 0xfafafa,//0x695b4e,
        transparent: true,
        opacity: 0.95,
        depthWrite: false,
        side: DoubleSide,
      });

      //Add grid group
      gridGroup = new Group();
      gridGroup.position.x = gridX;
      gridGroup.position.y = gridY;
      scene.add(gridGroup);


      //Calculate max z col and min z toe.
      let max_z_col = 0.0;
      let min_z_toe = Number.MAX_SAFE_INTEGER;
      jsonObjects.map(function(pile){
         let z_col = pile.z_col;
         let z_toe = pile.z_toe;

         if(z_col > max_z_col) {
           max_z_col = z_col;
         }

         if(z_toe < min_z_toe) {
           min_z_toe = z_toe;
         }
      });


      max_z_col *= pileDistance;
      min_z_toe *= pileDistance;
      let gridSeperationDistance = 5.0 * pileDistance; //5 meters

      //Add grids  from maz_z_col to every 5m until you reach below the  min_z_toe
      for(let initZCoord= max_z_col; initZCoord >= (min_z_toe - gridSeperationDistance); initZCoord-=gridSeperationDistance){
        let grid = new GridHelper(maxXY, gridSize, 0x9a9a9a, 0xdfdfdf);
        grid.geometry.rotateX( -Math.PI / 2 );
        grid.rotation.z = TMath.degToRad(initialRotation);
        grid.frustumCulled = false;
        grid.position.z = -initZCoord;
        gridGroup.add(grid);
      }


      let planeGeom = new PlaneBufferGeometry( 50, 50 );
      let planeMaterial = new MeshBasicMaterial( {color: 0x000000, transparent: true, opacity: 0.0} );
      transparentPlane = new Mesh( planeGeom, planeMaterial );
      scene.add(transparentPlane);

      let toePosns = [];
      let uninstalledPiles = [];
      let bbObject = new Object3D();

      if(currentDimension === '2d') {
        objects2d = [];
        let arrowGroup = new Group();
        arrowGroup.name = "bearingArrows";
        jsonObjects.map(function(pile)
        {
          let topPos = new Vector3(pile.x_col, pile.y_col, parseFloat(pile.z_col));
          let toePos = new Vector3(pile.x_toe, pile.y_toe, parseFloat(pile.z_toe));

          topPos.multiplyScalar(pileDistance).negate();
          toePos.multiplyScalar(pileDistance).negate();

          let  geometry = buildBox2D();

          let object = new Mesh(geometry, new MeshBasicMaterial({vertexColors : true, side: FrontSide }));

          object.pileID = pile.PileID;

          object.position.x = topPos.x;
          object.position.y = topPos.y;
          object.position.z = 10.0;

          object.rotation.x = 0;
          object.rotation.y = 0;
          object.rotation.z = 0;

          object.scale.z = pile.Total_Length > 0 ? (pile.Total_Length / highestPile) * 10 : 1;
          object.updateMatrixWorld(true);
          objects2d.push(object);
          scene.add( object );
          bbObject.add(object.clone());


          let bearing = parseFloat(pile.Bearing_drw);
          let bearingAngle = -bearing * (90.0/100.0) * (Math.PI/ 180.0);

          let quaternion = new Quaternion();
          //Rotate Around z Axis
          let yVec = new Vector3(0.0,1.0,0.0);
          quaternion.setFromAxisAngle( new Vector3( 0, 0, 1 ), -bearingAngle );
          yVec.applyQuaternion( quaternion );

          let length2 = 30;
          let hex2 = 0xff0000;

          let arrowHelperMain = new ArrowHelper( yVec, object.position, length2, hex2, 15, 15 );
          arrowHelperMain.children[0].material.depthTest = false;
          arrowHelperMain.children[1].material.depthTest = false;
          arrowHelperMain.userData = bearing;
          if(pile.Incl_drw != 0 && pile.Incl_drw != null){

            arrowGroup.add(arrowHelperMain);
          }

          let fakeObject = new Object3D();
          fakeObject.position.x = object.position.x;
          fakeObject.position.y = object.position.y;
          fakeObject.position.z = object.position.z;

          fakeObject.rotation.x =  object.rotation.x;
          fakeObject.rotation.y =  object.rotation.y;
          fakeObject.rotation.z =  object.rotation.z;
          fakeObject.scale.z = object.scale.z ;
          transparentPlane.add(fakeObject);

          let textBufferGeometry = makeLabel(currentDimension,pile);
          textLabelBufferGeometries.name = "textLabelBufferGeometries";
          textLabelBufferGeometries.push(textBufferGeometry);
        });

        //Add arrow group to the scene
        scene.add(arrowGroup);
      }
      else {
        objects3d = [];
        jsonObjects.map(function(pile)
        {
          let topPos = new Vector3(pile.x_col, pile.y_col, parseFloat(pile.z_col));
          let toePos = new Vector3(pile.x_toe, pile.y_toe, parseFloat(pile.z_toe));

          topPos.multiplyScalar(pileDistance).negate();
          toePos.multiplyScalar(pileDistance).negate();

          if(topPos.distanceTo(toePos) > 0.0) {
            toePosns.push(toePos);
            let  geometry = buildBox3D(topPos, toePos)
            let object = new Mesh(geometry, new MeshStandardMaterial( { vertexColors : true, side: DoubleSide } ));
            object.pileID = pile.PileID;
            object.frustumCulled = true;


            object.rotation.x = 0;
            object.rotation.y = 0;
            object.rotation.z = 0;


            objects3d.push(object);
            scene.add( object );
            bbObject.add(object.clone());

            let fakeObject = new Object3D();
            fakeObject.position.x = object.position.x;
            fakeObject.position.y = object.position.y;
            fakeObject.position.z = object.position.z;

            fakeObject.rotation.x =  object.rotation.x;
            fakeObject.rotation.y =  object.rotation.y;
            fakeObject.rotation.z =  object.rotation.z;
            fakeObject.scale.z = object.scale.z ;
            transparentPlane.add(fakeObject);

            let textLabelMeshes = makeLabel(currentDimension, pile);
            textLabelBufferGeometries.push(textLabelMeshes);
          }
          else {
            uninstalledPiles.push({pile: pile, topPos: topPos});
          }
        });

        //Add terrain
        let indexDelaunay = Delaunator.from(
            toePosns.map(v => {
              return [v.x, v.y];
            })
        );
        let terrainMeshArray = [];
        let terrainGeom = new BufferGeometry().setFromPoints(toePosns);
        let meshIndex = []; // delaunay index => three.js index
        for (let i = 0; i < indexDelaunay.triangles.length; i++){
          meshIndex.push(indexDelaunay.triangles[i]);
        }
        terrainGeom.setIndex(meshIndex); // add three.js index to the existing geometry
        terrainGeom.computeVertexNormals();

        //Add terrain wireframe
        let terrainWireFrame = new WireframeGeometry( terrainGeom );
        let terrainLines = new LineSegments( terrainWireFrame, new MeshLambertMaterial({ color: 0x000000, opacity: 0.2, side: DoubleSide }) );
        scene.add( terrainLines );

        //Solid terrain
        let terrainMeshSolid = new Mesh(
            terrainGeom, // re-use the existing geometry
            new MeshStandardMaterial({ color: 0xc68767, side: DoubleSide, wireframe: false })
        )
        terrainMeshSolid.updateMatrixWorld(true);
        terrainMeshArray.push(terrainMeshSolid);
        scene.add(terrainMeshSolid);

        //Compute toe positions
        for(let i=0; i < uninstalledPiles.length; ++i) {

          let uPile = uninstalledPiles[i];


          let inclination = parseFloat(uPile.pile.Incl_drw);
          let data_inclination = uPile.pile.Incl_drw;
          let inclinationAngle;
          if(data_inclination === 0 || data_inclination === "NULL"  ){
            inclinationAngle = 0;// Math.atan(0) = 0

          }else {
            inclinationAngle = Math.atan(1 /inclination);// * (Math.PI/ 180.0);

          }

          let bearing = parseFloat(uPile.pile.Bearing_drw);

          let bearingAngle = -bearing * (90.0/100.0) * (Math.PI/ 180.0);

          //Rotate around y axis
          let quaternion2 = new Quaternion();
          let zVec = new Vector3(0.0,0.0,1.0);

          quaternion2.setFromAxisAngle( new Vector3( 1.0, 0.0, 0.0 ), -inclinationAngle );
          zVec.applyQuaternion( quaternion2 );

          let quaternion = new Quaternion();
          //Rotate Around z Axis
          quaternion.setFromAxisAngle( new Vector3( 0, 0, 1 ), -bearingAngle );
          zVec.applyQuaternion( quaternion );

          let newOrigin = uPile.topPos;

          let raycaster = new Raycaster();
          zVec.normalize();
          raycaster.set(newOrigin, zVec);
          // calculate objects intersecting the picking ray
          let intersects = raycaster.intersectObjects( terrainMeshArray );

          if(intersects.length > 0) {
            let toePos = intersects[0].point;
            let  geometry = buildBox3D(uPile.topPos, toePos)
            let object = new Mesh(geometry, new MeshStandardMaterial( { vertexColors:true, side: FrontSide } ));
            object.pileID = uPile.pile.PileID;
            object.frustumCulled = true;

            uPile.pile.TriangulatedLength = intersects[0].distance / pileDistance;

            let pileRootJson = jsonObjects.find(pile => pile["PileID"] === uPile.pile["PileID"]);
            pileRootJson["Effective_length"] = uPile.pile.TriangulatedLength;
            //console.log("Effectiv length for pile id ",uPile.pile["PileID"]," is =",pileRootJson["Effective_length"]);

            object.rotation.x = 0;
            object.rotation.y = 0;
            object.rotation.z = 0;

            objects3d.push(object);
            scene.add( object );
            bbObject.add(object.clone());

            let fakeObject = new Object3D();
            fakeObject.position.x = object.position.x;
            fakeObject.position.y = object.position.y;
            fakeObject.position.z = object.position.z;

            fakeObject.rotation.x =  object.rotation.x;
            fakeObject.rotation.y =  object.rotation.y;
            fakeObject.rotation.z =  object.rotation.z;
            fakeObject.scale.z = object.scale.z ;
            transparentPlane.add(fakeObject);

            let textLabelMeshes = makeLabel(currentDimension, uPile.pile);
            textLabelBufferGeometries.push(textLabelMeshes);
          }
        }

        //Compute target pos and camera position dynamically.
        const bbox = new Box3().setFromObject(bbObject);
        const center = bbox.getCenter(new Vector3());
        if(currentDimension === "3d") {
          camera.position.set(center.x, bbox.min.y * 1.5, bbox.min.z * 1.5);
          controls.target.set(center.x, 0.0, center.z);
          controls.update();
        }
        bbObject = null;
        //end target pos
      }

      if(currentDimension === '2d') {
        textLabelsFor2D = new Group();
        for(let i=0; i < textLabelBufferGeometries.length; ++i) {
          textLabelBufferGeometries[i].material = textMaterial2D;
          textLabelBufferGeometries[i].frustumCulled = true;
          textLabelBufferGeometries[i].name = "2dtextmesh " + i;
          textLabelsFor2D.add(textLabelBufferGeometries[i]);
        }
        scene.add(textLabelsFor2D);
      }
      else {
        textLabelsFor3D = new Group();
        for(let i=0; i < textLabelBufferGeometries.length; ++i) {
          textLabelBufferGeometries[i].material = textMaterial3D;
          textLabelBufferGeometries[i].frustumCulled = true;
          textLabelBufferGeometries[i].name = "3dtextmesh " + i;
          textLabelsFor3D.add(textLabelBufferGeometries[i]);
        }
        scene.add(textLabelsFor3D);
      }

      changeColors();
    }

    function remakeLabels(positionArray) {
      labels.map(function(label) {
        if(textLabelsFor2D) {
          for(let i=0; i< textLabelsFor2D.children.length; ++i) {
            let meshToRemove = textLabelsFor2D.children[i];
            meshToRemove.geometry.dispose();
            meshToRemove.material.dispose();
          }
          scene.remove(textLabelsFor2D);
        }
        else if(textLabelsFor3D){ //3d
          for(let i=0; i< textLabelsFor3D.children.length; ++i) {
            let meshToRemove = textLabelsFor3D.children[i];
            meshToRemove.geometry.dispose();
            meshToRemove.material.dispose();
          }
          scene.remove(textLabelsFor3D);
        }
      });

      labels = [];
      textLabelBufferGeometries = [];

      if (labelType !== 'none') {
        let posCount = 0;
        jsonObjects.map(function(pile) {
          let translatedPosition;
          if(positionArray !== undefined)
            translatedPosition = positionArray[posCount];
          let textBufferGeometry = makeLabel(currentDimension, pile, translatedPosition);
          textLabelBufferGeometries.push(textBufferGeometry);
          ++posCount;
        });

        if(currentDimension === '2d') {
          textLabelsFor2D = new Group();
          for(let i=0; i < textLabelBufferGeometries.length; ++i) {
            textLabelBufferGeometries[i].material = textMaterial2D;
            textLabelBufferGeometries[i].frustumCulled = true;
            textLabelBufferGeometries[i].name = "2dtextmesh " + i;
            textLabelsFor2D.add(textLabelBufferGeometries[i]);
          }
          scene.add(textLabelsFor2D);
        }
        else {
          textLabelsFor3D = new Group();
          for(let i=0; i < textLabelBufferGeometries.length; ++i) {
            textLabelBufferGeometries[i].material = textMaterial3D;
            textLabelBufferGeometries[i].frustumCulled = true;
            textLabelBufferGeometries[i].name = "3dtextmesh " + i;
            textLabelsFor3D.add(textLabelBufferGeometries[i]);
          }
          scene.add(textLabelsFor3D);
        }
      }
    }

    function changeColors() {


      if(currentDimension === '3d') {
        let half = true;
        objects3d.map(function(obj) {
          let pile = jsonObjects.find(function(pile) {
            return pile.PileID == obj.pileID;
          });

          if (pile[filterType1] === 1 && pile[filterType2] === 1) {
            for ( let i = 0; i < obj.geometry.faces.length; i ++ ) {
              if(i <= 11 )
                obj.geometry.faces[i].color.setHex(yellow);
              else
                obj.geometry.faces[i].color.setHex(red);
            }
          }
          else if (pile[filterType1] === 1) {
            for ( let i = 0; i < obj.geometry.faces.length; i ++ ) {
              obj.geometry.faces[i].color.setHex(yellow);
            }
          } else if (pile[filterType2] === 1) {
            for ( let i = 0; i < obj.geometry.faces.length; i ++ ) {
              obj.geometry.faces[i].color.setHex(red);
            }
          } else {
            for ( let i = 0; i < obj.geometry.faces.length; i ++ ) {
              obj.geometry.faces[i].color.setHex(dim.pileColor(pile));
            }
          }
          obj.geometry.colorsNeedUpdate = true;
        });
      }
      else {
        let half = true;
        objects2d.map(function(obj) {
          let pile = jsonObjects.find(function(pile) {
            return pile.PileID == obj.pileID;
          });

          if (pile[filterType1] === 1 && pile[filterType2] === 1) {
            for ( let i = 0; i < obj.geometry.faces.length; i ++ ) {
              if(i===0 || i ===1 )
                obj.geometry.faces[i].color.setHex(yellow);
              else
                obj.geometry.faces[i].color.setHex(red);
            }
          }
          else if (pile[filterType1] === 1) {
            for ( let i = 0; i < obj.geometry.faces.length; i ++ ) {
              obj.geometry.faces[i].color.setHex(yellow);
            }
          } else if (pile[filterType2] === 1) {
            for ( let i = 0; i < obj.geometry.faces.length; i ++ ) {
              obj.geometry.faces[i].color.setHex(red);
            }
          } else {
            for ( let i = 0; i < obj.geometry.faces.length; i ++ ) {
              obj.geometry.faces[i].color.setHex(dim.pileColor(pile.RigID));
            }
          }
          obj.geometry.colorsNeedUpdate = true;
        });
      }
    }

    function transformTextVertices(textGeometry, localMatrix) {
      let vertexAttribute = textGeometry.getAttribute('position');
      for(let i=0; i < vertexAttribute.array.length; i=i+3 )
      {
        let textVertex = new Vector3(vertexAttribute.array[i],vertexAttribute.array[i+1],vertexAttribute.array[i+2]);
        textVertex.applyMatrix4(localMatrix);
        vertexAttribute.array[i]=  textVertex.x;
        vertexAttribute.array[i+1]= textVertex.y;
        vertexAttribute.array[i+2]= textVertex.z;
      }
      return textGeometry;
    }

    function makeLabel(lType, pile, position) {
      if(lType === "2d"){
        return makeLabel2D(pile, position);
      }
      else {
        return makeLabel3D(pile, position);
      }
    }

    function makeLabel2D(pile, position) {
      let label = makeTextSprite("2d",pile);

      label.sprite.pileID = pile.PileID;
      let vertical_shift = 20;
      let horizontal_shift = 20 * labelFontSize;
      let posX = position !== undefined ? position.x + horizontal_shift : -( pile.x_col * pileDistance - horizontal_shift);
      let posY = position !== undefined ? position.y + vertical_shift : -( pile.y_col * pileDistance - vertical_shift);

      label.sprite.position.x = posX;
      label.sprite.position.y = posY;
      label.sprite.position.z = 10;// - pile.Effektiv_langd;
      let scaleLabel = labelFontSize;
      label.sprite.scale.x =  scaleLabel;
      label.sprite.scale.y =  scaleLabel;
      label.sprite.scale.z =  scaleLabel;
      let textMesh = label.sprite;
      labels.push(textMesh);
      return textMesh;
    }

    function makeLabel3D(pile, position) {
      let label = makeTextSprite("3d", pile);
      label.sprite.pileID = pile.PileID;
      let vertical_shift = 20;
      let horizontal_shift = 20 * labelFontSize;
      let posX = position !== undefined ? position.x + horizontal_shift : -( pile.x_col * pileDistance - horizontal_shift);
      let posY = position !== undefined ? position.y + vertical_shift : -( pile.y_col * pileDistance - vertical_shift);
      let posZ = -(parseFloat(pile.z_col) * pileDistance);

      label.sprite.position.x = posX;
      label.sprite.position.y = posY + 15; //Show it 10 units above
      label.sprite.position.z = posZ;// - pile.Effektiv_langd;
      let scaleLabel = labelFontSize;
      label.sprite.scale.x =  scaleLabel;
      label.sprite.scale.y =  scaleLabel;
      let textMesh = label.sprite;
      // textMesh.rotateY(-Math.PI);
      // textMesh.rotateX(Math.PI/2);
      //textMesh.updateMatrix();
      //let localMatrix = textMesh.matrix;
      //transformTextVertices(textMesh.geometry,localMatrix);
      labels.push(label.sprite);
      return textMesh;
    }

    function onWindowResize() {
      camera.aspect = window.innerWidth / window.innerHeight;
      camera.updateProjectionMatrix();
      renderer.setSize(window.innerWidth, window.innerHeight);
    }

    function onDocumentMouseMove( event ) {
      event.preventDefault();

      let rect = event.target.getBoundingClientRect();
      let y = event.clientY - rect.top;
      let x = event.clientX - rect.left;

      mouse.x = ( x / rect.width ) * 2 - 1;
      mouse.y = - ( y / rect.height ) * 2 + 1;
    }

    function animate() {
      reqAnimFrameId = requestAnimationFrame( animate );

      // stats.begin();
      render();
      // stats.end();
    }

    function render() {
      gridGroup.position.x = -gridX;
      gridGroup.position.y = -gridY;

      if(oldProjectBearing !== newProjectBearing){
        let arrowGroup = scene.getObjectByName('bearingArrows');
        for(let i=0; i<arrowGroup.children.length;i++){
          let arrowObj = arrowGroup.children[i];
          let bearing = arrowObj.userData;
          bearing = bearing + (newProjectBearing - oldProjectBearing);
          let bearingAngle = -bearing * (90.0/100.0) * (Math.PI/ 180.0);

          let quaternion = new Quaternion();
          //Rotate Around z Axis
          let yVec = new Vector3(0.0,1.0,0.0);
          quaternion.setFromAxisAngle( new Vector3( 0, 0, 1 ), -bearingAngle );
          yVec.applyQuaternion( quaternion );

          let length2 = 30;
          let hex2 = 0xff0000;

          let arrowHelperUpdated = new ArrowHelper( yVec, arrowObj.position, length2, hex2, 15, 15 );
          arrowHelperUpdated.children[0].material.depthTest = false;
          arrowHelperUpdated.children[1].material.depthTest = false;
          arrowHelperUpdated.userData = bearing;

          //Remove old arrow
          arrowGroup.children[i] = null;
          //Add new arrow
          arrowGroup.children[i] = arrowHelperUpdated;
        }
        // update arrowhelper with difference in old/new bearing together with current direction
        oldProjectBearing = newProjectBearing;
      }


      // find intersections
      raycaster.setFromCamera( mouse, camera );

      let objects = [];
      if(currentDimension === '3d'){
        objects = objects3d;
      }
      else {
        objects = objects2d;
      }
      if(objects){

        let intersects = raycaster.intersectObjects( objects );
        //intersects = intersects.concat(raycaster.intersectObjects( labels ));

        if ( intersects.length > 0 ) {

          if ( INTERSECTED != intersects[ 0 ].object ) {

            if ( INTERSECTED && INTERSECTED.material !== null ) INTERSECTED.material.color.setHex( INTERSECTED.currentHex );

            INTERSECTED = intersects[ 0 ].object;
            INTERSECTED.currentHex = INTERSECTED.material.color.getHex();
            INTERSECTED.material.color.setHex( 0xeae3c2 );
          }

          if (togglePopup === true && hidePopup === false) {
            let obj = intersects[0].object;
            let pile = jsonObjects.find(function(pile) {
              return pile.PileID == obj.pileID;
            });

            clearPopup();
            infoPopup(pile);
          } else if (hidePopup === true) {
            clearPopup();
          }
        } else {

          if ( INTERSECTED && INTERSECTED.material !== null ){
            INTERSECTED.material.color.setHex( INTERSECTED.currentHex );
          }

          INTERSECTED = null;

          if (togglePopup === true || hidePopup === true)
            clearPopup();

        }
      }

      const delta = clock.getDelta();
      if(controls instanceof CameraControls)
        controls.update( delta );
      else
        controls.update();

      if(textLabelsFor2D) {
        for(let i=0; i< textLabelsFor2D.children.length; ++i) {
          let textLabel = textLabelsFor2D.children[i];
          textLabel.quaternion.copy(camera.quaternion);
        }
      }


      renderer.render( scene, camera );
    }

    function infoPopup(pile) {
      let info = document.createElement('div');
      let width = 250;
      let height = !document.querySelector("#pile-type-btg-or-steel") ? 300 : 190;

      let left = previousMousePos.x - (width / 2);
      let top  = previousMousePos.y + 25;
      let canvas = document.getElementById('pileMap');

      if (left + width > canvas.offsetWidth) {
        left = previousMousePos.x - width - 15;
        top = top - (height / 2) - 25;
      }

      if (top + height > canvas.offsetHeight) {
        top = previousMousePos.y - height - 5;
      }

      if (top < 0) {
        top = 5;
      }
      if (left < 0) {
        left = 5;
      }

      pile.Estimated_length = parseFloat(pile.Estimated_length);


      // Create the popup
      info.id = "infoPopup";

      // Give it a size
      info.style.setProperty('width', width + 'px');
      info.style.setProperty('height', height + 'px');

      // Position it properly
      info.style.setProperty('position', 'absolute');
      info.style.setProperty('left', left + 'px');
      info.style.setProperty('top', top + 'px');

      // And make it look nice
      info.style.setProperty('background-color', 'rgb(255, 238, 238)');
      info.style.setProperty('color', '#232323');
      info.style.setProperty('padding', '1em');
      info.style.setProperty('line-height', '1.3em');

      // And fill it with info about the pile
      let content = "";
      content += 'P&aring;lnr: ' + pile.PileID + "<br />";
      content += 'KranID: ' + pile.RigID + "<br />";
      content += 'P&aring;ltyp: ' + pile.PileType + "<br />";
      content += 'Totall&auml;ngd: ' + pile.Total_Length + "<br />";
      if(pile.TriangulatedLength){
        content += 'Triangulerad l&auml;ngd: ' +  (Math.round((pile.TriangulatedLength + Number.EPSILON) * 100) / 100 )+"<br />";
      }else{
        content += 'Triangulerad l&auml;ngd: - <br />';
      }
      if(pile.Estimated_length){
        content += 'Bed&ouml;md l&auml;ngd: ' + Math.round(( pile.Estimated_length + Number.EPSILON) * 100) / 100 + '<br />';
      }else{
        content += 'Bed&ouml;md l&auml;ngd: - <br />';
      }
      content += 'Effektiv l&auml;ngd: ' + pile.Effective_length + "<br />";
      content += 'Niv&aring; avsk&auml;rning: ' + pile.z_col + "<br />";
      content += 'Slagningsdatum: ' + pile.Inst_date + "<br />";
      content += 'Stoppslag: ' + pile.EDO_set;

      info.innerHTML = content;

      // Let's add those buttons too, if we're not on the web
      if (!document.querySelector("#pile-type-btg-or-steel")) {
        let pileButton = document.createElement('div');
        pileButton.id = "pileCurrentPile";
        pileButton.classList.add('pileMapPopupButton');
        pileButton.style.setProperty('background-color', 'green');
        pileButton.innerHTML = "P&aring;la";
        pileButton.addEventListener('click', function() {
          window.location.href = "app://" + pile.PileID.trim() + "/"+ pile.RigID;
          hidePopup = true;
        });

        info.appendChild(pileButton);
      }

      // Close button should be there regardless
      let closeButton = document.createElement('div');
      closeButton.id = "closePileInfoPopup";
      closeButton.classList.add('pileMapPopupButton');
      closeButton.style.setProperty('background-color', 'red');
      closeButton.innerHTML = "St&auml;ng";
      closeButton.addEventListener('click', function() {
        hidePopup = true;
      });

      info.appendChild(closeButton);

      // Append the popup to the body
      document.body.appendChild(info);
      togglePopup = false;
    }

    function clearPopup() {
      let infoPopup = document.getElementById('infoPopup');
      if (document.body.contains(infoPopup)) {
        infoPopup.parentNode.removeChild(infoPopup);
      }
      togglePopup = false;
      hidePopup = false;
    }

    function initializeEvents() {
      let pileMap = document.getElementById('pileMap');

      // pileMap.addEventListener('mousedown', togglePop, { passive: false }); // We dont want info when trying to move the camera
      // pileMap.addEventListener('touchstart', togglePop, { passive: false }); // We dont want info when trying to move the camera
      pileMap.addEventListener('mousedown', onDownInteraction, { passive: false });
      pileMap.addEventListener('mouseup', togglePop, { passive: false });
      pileMap.addEventListener('touchstart', onDownInteraction, { passive: false });
      pileMap.addEventListener('touchend', togglePop, { passive: false });


      // if(document.getElementById("printDrawing")){
        //   document.getElementById("printDrawing").addEventListener('click', () => {
      // if(document.querySelector('.pileMapContainer' + type + ' #printBtn')) {
      //   document.querySelector('.pileMapContainer' + type + ' #printBtn').addEventListener('click', () => {
      //
      //
      //     let top_left_margin = 15;
      //     let PDF_Width = renderer.domElement.clientWidth+(top_left_margin*2);
      //     let PDF_Height = (PDF_Width*1.5)+(top_left_margin*2);
      //
      //     //This downloads the PDF file
      //     let dataUrl = renderer.domElement.toDataURL('image/png');
      //     window.open(dataUrl);
      //     let pdfDoc = new jsPDF('p', 'pt',  [PDF_Width, PDF_Height]);
      //     pdfDoc.addImage(dataUrl, 'PNG',0,0, renderer.domElement.clientWidth,renderer.domElement.clientHeight);
      //     // pdfDoc.save('PILE_DRAWING.pdf');
      //   }, { passive: false });
      // }
      if(document.querySelector('.pileMapContainer' + type + ' #printBtn')) {
        document.querySelector('.pileMapContainer' + type + ' #printBtn').addEventListener('click', () => {
          let top_left_margin = 15;
          let PDF_Width = renderer.domElement.clientWidth+(top_left_margin*2);
          let PDF_Height = (PDF_Width*1.5)+(top_left_margin*2);

          let imgBlob = renderer.domElement.toBlob((blob) => {
            saveBlob(blob,'pilemap.png');

          });

          const saveBlob = (function() {
            const img = document.createElement('img');
            document.body.appendChild(img);
            img.style.display = 'none';
            return function saveData(blob, fileName) {
               const url = window.URL.createObjectURL(blob);
               img.href = url;
               img.save = fileName;
               window.open(url);
               img.click();
               document.body.removeChild(img);
            };
          }());

        }, { passive: false });
      }

      function resetPreference(){
        $.ajax({
          url:'updatePreferences.php',
          type:'POST',
          dataType:'json',
          data: {
            reset: true
          },
          success: function(data,status){
          }
        });

        cameraPosition.x = ((((maxX/ 2) * (pileDistance/ 2)) * Math.sin( TMath.degToRad( 0.2 ) )) + ((maxX / 2) * pileDistance) - (25 * pileDistance) );
        cameraPosition.y = ((((maxY/ 2) * (pileDistance/ 2)) * Math.sin( TMath.degToRad( 0.2 ) )) + ((maxY / 2) * pileDistance) - (25 * pileDistance) );
        // cameraPosition.x = maxX * 6.67;
        // cameraPosition.y = maxY * 6.67;

        camera.position.x = -cameraPosition.x;
        camera.position.y = -cameraPosition.y;
        camera.position.z = -550;

        //Reset Orbitcontrols Target.
        if(controls instanceof  CameraControls)
          controls.moveTo(-cameraPosition.x, -cameraPosition.y, 0);
        else {
          controls.target = new Vector3(-cameraPosition.x, -cameraPosition.y, 0 );
        }
      }

// reset button for preferences, used if users coordinates does not show them any piles
      if(document.querySelector('#resetPreferenceBtg')){
        document.querySelector('#resetPreferenceBtg').addEventListener('click', () => {
          resetPreference();
        });
      }

// reset button for preferences, used if users coordinates does not show them any piles
      if(document.querySelector('#resetPreferenceSteel')){
        document.querySelector('#resetPreferenceSteel').addEventListener('click', () => {
          resetPreference();
        });
      }

      if (!document.querySelector("#pile-type-btg-or-steel")) {
        pileMap.addEventListener('click', togglePop, { passive: false });
      }


      [].slice.call(document.querySelectorAll(`input[name="pileMapLabel${type}"]`)).map(function (option) {
        option.addEventListener('change', function() {
          labelType = this.value;
          remakeLabels();
        });
      });

      [].slice.call(document.querySelectorAll(`input[name="pileMapFilter1${type}"]`)).map(function (option) {
        option.addEventListener('change', function() {
          filterType1 = this.value;
          changeColors();
        });
      });

      [].slice.call(document.querySelectorAll(`input[name="pileMapFilter2${type}"]`)).map(function (option) {
        option.addEventListener('change', function() {
          filterType2 = this.value;
          changeColors();
        });
      });



      document.querySelector('.pileMapContainer' + type + ' .toggle-interface').addEventListener('click', toggleInterface);


      makePointerEvent(".pileMapContainer" + type + ' #rotate90', rotate90Down, rotate90Up);
      makePointerEvent(".pileMapContainer" + type + ' #rotateMinus90', rotateMinus90Down, rotateMinus90Up);

      makePointerEvent(".pileMapContainer" + type + ' .navigateGridUp', moveGridMinusYDown, moveGridMinusYUp);
      makePointerEvent(".pileMapContainer" + type + ' .navigateGridDown', moveGridPlusYDown, moveGridPlusYUp);
      makePointerEvent(".pileMapContainer" + type + ' .navigateGridLeft', moveGridMinusXDown, moveGridMinusXUp);
      makePointerEvent(".pileMapContainer" + type + ' .navigateGridRight', moveGridPlusXDown, moveGridPlusXUp);
      makePointerEvent(".pileMapContainer" + type + ' .textScaler', changeTextScaleKeyDown, changeTextScaleKeyUp);

// Testing for mobile app if in steel or concrete
      if(document.querySelector("#project_bearing_steel_form")){
        document.querySelector("#project_bearing_steel_form").addEventListener("submit", submit_project_bearing_steel);
        document.querySelector("#submit_project_bearing_steel").addEventListener("click",submit_project_bearing_steel);
      }
      if(document.querySelector("#project_bearing_btg_form")){
      document.querySelector("#project_bearing_btg_form").addEventListener("submit", submit_project_bearing_btg);
      document.querySelector("#submit_project_bearing_btg").addEventListener("click", submit_project_bearing_btg);
      }

    }

    function makePointerEvent(element, methodDown, methodUp) {
      document.querySelector(element).addEventListener('pointerdown', methodDown, { passive: false });
      document.querySelector(element).addEventListener('touchstart', methodDown, { passive: false });
      document.querySelector(element).addEventListener('pointerup', methodUp, { passive: false });
      document.querySelector(element).addEventListener('touchend', methodUp, { passive: false });

      if (!document.querySelector("#pile-type-btg-or-steel")) {
        document.querySelector(element).addEventListener('mousedown', methodDown, { passive: false });
        document.querySelector(element).addEventListener('mouseup', methodUp, { passive: false });
      }

      document.querySelector(element).addEventListener('click', function(e) { e.preventDefault(); }, {passive: false});
      document.querySelector(element).addEventListener('contextmenu', function(e) { e.preventDefault(); }, {passive: false});
    }

    function clearEvents() {
      let pileMap = document.getElementById('pileMap');

      if (pileMap) {
        pileMap.removeEventListener('mousedown', onDownInteraction);
        pileMap.removeEventListener('mouseup', togglePop);
        pileMap.removeEventListener('touchstart', onDownInteraction);
        pileMap.removeEventListener('touchend', togglePop);
      }

      document.querySelector('.pileMapContainer' + type + ' .toggle-interface').removeEventListener('click', toggleInterface);

      document.querySelector(".pileMapContainer" + type + ' #rotate90').removeEventListener('pointerdown', rotate90Down);
      document.querySelector(".pileMapContainer" + type + ' #rotate90').removeEventListener('touchstart', rotate90Down);
      document.querySelector(".pileMapContainer" + type + ' #rotate90').removeEventListener('pointerup', rotate90Up);
      document.querySelector(".pileMapContainer" + type + ' #rotate90').removeEventListener('touchend', rotate90Up);

      document.querySelector(".pileMapContainer" + type + ' #rotateMinus90').removeEventListener('pointerdown', rotateMinus90Down);
      document.querySelector(".pileMapContainer" + type + ' #rotateMinus90').removeEventListener('touchstart', rotateMinus90Down);
      document.querySelector(".pileMapContainer" + type + ' #rotateMinus90').removeEventListener('pointerup', rotateMinus90Up);
      document.querySelector(".pileMapContainer" + type + ' #rotateMinus90').removeEventListener('touchend', rotateMinus90Up);

      document.querySelector(".pileMapContainer" + type + ' #rotate90').removeEventListener('click', function(e) { e.preventDefault() });
      document.querySelector(".pileMapContainer" + type + ' #rotate90').removeEventListener('contextmenu', function(e) { e.preventDefault() });
      document.querySelector(".pileMapContainer" + type + ' #rotateMinus90').removeEventListener('click', function(e) { e.preventDefault() });
      document.querySelector(".pileMapContainer" + type + ' #rotateMinus90').removeEventListener('contextmenu', function(e) { e.preventDefault() });
        // Testing for mobile app if in steel or concrete
      if(document.querySelector("#project_bearing_steel_form")){
      document.querySelector("#project_bearing_steel_form").removeEventListener("submit",  submit_project_bearing_steel);
      document.querySelector("#submit_project_bearing_steel").removeEventListener("click", submit_project_bearing_steel);
      }
      if(document.querySelector("#project_bearing_btg_form")){
        document.querySelector("#project_bearing_btg_form").removeEventListener("submit", submit_project_bearing_btg);
        document.querySelector("#submit_project_bearing_btg").removeEventListener("click", submit_project_bearing_btg);
      }

    }

    function changeTextScaleKeyDown(){
    }

    function changeTextScaleDrag(){
      $('.pileMapTextScale').text(this.value);
    }

    function changeTextScaleKeyUp(){
      labelFontSize = $(".pileMapContainer" + type + ' .textScaler').attr("value");
      $('.pileMapTextScale').text("x"+this.value);

      remakeLabels();
    }
    function togglePop(e) {
      e.preventDefault();

      let objects = currentDimension == '3d' ? objects3d : false;
      if(objects){
        raycaster.setFromCamera( mouse, camera );
        let intersects = raycaster.intersectObjects(objects);
        if(intersects.length >0){
          let obj = intersects[0].object;
          if(obj === prevObj){

            togglePopup = !togglePopup;
          }
        }
      }else if (currentDimension == '2d') {
        togglePopup = !togglePopup;
      }
    }

    function toggleInterface() {
      document.querySelector('.pileMapContainer' + type + ' .interface').classList.toggle('hidden');
      document.querySelector('.pileMapContainer' + type + ' .toggle-interface').classList.toggle('hidden');
    }

    function rotate90Down(e) {
      e.preventDefault();
      rotateBool = true;
      rotateDelta = 1;
      rotate();
    }

    function rotateMinus90Down(e) {
      e.preventDefault();
      rotateBool = true;
      rotateDelta = -1;
      rotate();
    }

    function rotate90Up(e) {
      e.preventDefault();
      rotateBool = false;
      rotateDelta = 0;
      rotateTime = defaultRotateTime;
      clearTimeout(rotateTimer);
    }

    function rotateMinus90Up(e) {
      e.preventDefault();
      rotateBool = false;
      rotateDelta = 0;
      rotateTime = defaultRotateTime;
      clearTimeout(rotateTimer);
    }

    /**
     * GRID - MOVE Y UPWARDS
     */
    function moveGridMinusYDown(e) {
      e.preventDefault();
      moveGridBool = true;
      moveGridDirection = GRID_DIRECTION.Y;
      moveGridDelta = -30;
      moveGrid();
    }

    function moveGridMinusYUp(e) {
      e.preventDefault();
      moveGridBool = false;
      moveGridDirection = 0;
      moveGridDelta = 0;
      moveGridTime = defaultMoveGridTime;
      clearTimeout(moveGridTimer);
    }

    /**
     * GRID - MOVE Y DOWNWARDS
     */
    function moveGridPlusYDown(e) {
      e.preventDefault();
      moveGridBool = true;
      moveGridDirection = GRID_DIRECTION.Y;
      moveGridDelta = 30;
      moveGrid();
    }

    function moveGridPlusYUp(e) {
      e.preventDefault();
      moveGridBool = false;
      moveGridDirection = 0;
      moveGridDelta = 0;
      moveGridTime = defaultMoveGridTime;
      clearTimeout(moveGridTimer);
    }

    /**
     * GRID - MOVE X LEFT
     */
    function moveGridMinusXDown(e) {
      e.preventDefault();
      moveGridBool = true;
      moveGridDirection = GRID_DIRECTION.X;
      moveGridDelta = -30;
      moveGrid();
    }

    function moveGridMinusXUp(e) {
      e.preventDefault();
      moveGridBool = false;
      moveGridDirection = 0;
      moveGridDelta = 0;
      moveGridTime = defaultMoveGridTime;
      clearTimeout(moveGridTimer);
    }

    /**
     * GRID - MOVE X RIGHT
     */
    function moveGridPlusXDown(e) {
      e.preventDefault();
      moveGridBool = true;
      moveGridDirection = GRID_DIRECTION.X;
      moveGridDelta = 30;
      moveGrid();
    }

    function moveGridPlusXUp(e) {
      e.preventDefault();
      moveGridBool = false;
      moveGridDirection = 0;
      moveGridDelta = 0;
      moveGridTime = defaultMoveGridTime;
      clearTimeout(moveGridTimer);
    }

    function submit_project_bearing_steel(){
      submit_project_bearing('steel');
    }

    function submit_project_bearing_btg(){
      submit_project_bearing('btg');
    }

    function submit_project_bearing(type){
      event.preventDefault();
      let formData = new FormData();
      let direction = $("#project_bearing_"+type+"_text").val();
      type = type == 'btg' ? 'steel' : 'btg';
      formData.append("direction",  direction);
      $.ajax({
        url: "WS_setProjectBearing.php",
        type: "POST",
        dataType: "xml",
        processData: false,
        contentType: false,
        data: formData,
        error: function(data){
          alertNice(data['responseText']);

        },
        success: function(data, statustext){
          newProjectBearing = direction;
          $("#project_bearing_"+type+"_text").val(direction);
        }
      })
    };

    function onDownInteraction(e) {
      e.preventDefault();

      let mousePtr = [];
      if (e.touches) {
        mousePtr = Array.prototype.slice.call(e.touches);
      } else {
        mousePtr.push(e);
      }
      let rect = mousePtr[0].target.getBoundingClientRect();
      let y = mousePtr[0].clientY - rect.top;
      let x = mousePtr[0].clientX - rect.left;
      mouse.x = ( x / rect.width ) * 2 - 1;
      mouse.y = - ( y / rect.height ) * 2 + 1;
      previousMousePos = { x: x, y: y };

      if (currentDimension === '3d') {
        // controls.lock();
      }
      let objects = currentDimension == '3d' ? objects3d : false;
      if(objects){

        raycaster.setFromCamera( mouse, camera );
        let intersects = raycaster.intersectObjects(objects);
        if(intersects.length >0){
          prevObj = intersects[0].object;
        }else{
          prevObj = false;
        }
      } else{
        prevObj = false;
      }
    }

    function rotate() {
      if (rotateBool) {
        gridRotY = +gridRotY + (1 * rotateDelta);

        if (gridRotY === -1) {
          gridRotY = 359;
        } else if (gridRotY === 360) {
          gridRotY = 0;
        }

        document.querySelector(".pileMapContainer" + type + ' #rotation').innerText = gridRotY;

        if (rotateTime > 50) {
          rotateTime -= 50;
        }

        controls.rotate(   -rotateDelta * THREE.MathUtils.DEG2RAD, 0, true );
        rotateTimer = setTimeout(rotate, rotateTime);
      }
    }

    function moveGrid() {
      if (moveGridBool) {
        if (moveGridDirection === GRID_DIRECTION.X) {
          gridX = +gridX + moveGridDelta;
        } else if (moveGridDirection === GRID_DIRECTION.Y) {
          gridY = +gridY + moveGridDelta;
        }

        if (moveGridTime > 5) {
          moveGridTime -= 5;
        }

        moveGridTimer = setTimeout(moveGrid, moveGridTime);
      }
    }

    function modifyVertexArray2D(vertexArray, zPos) {
      let newLength = ((vertexArray.length/2) * 3);
      let modifiedArray = new Float32Array(newLength);
      for(let i=0, j=0; j < vertexArray.length; i=i+3, j=j+2 )
      {
        modifiedArray[i] = vertexArray[j];
        modifiedArray[i+1] = -vertexArray[j+1];
        modifiedArray[i+2] = (zPos);
      }
      return modifiedArray;
    }

    function modifyVertexArray3D(vertexArray, zPos) {
      let newLength = ((vertexArray.length/2) * 3);
      let modifiedArray = new Float32Array(newLength);
      for(let i=0, j=0; j < vertexArray.length; i=i+3, j=j+2 )
      {
        modifiedArray[i] = vertexArray[j];
        modifiedArray[i+1] = vertexArray[j+1];
        modifiedArray[i+2] = (zPos);
      }
      return modifiedArray;
    }


    // This was written by Lee Stemkoski
    // https://stemkoski.github.io/Three.js/Sprite-Text-Labels.html
    function makeTextSprite( typeg, pile, parameters )
    {
      let pileLabel = "";
      if( labelType === "Total_Length"|| labelType === "Effective_length"){
        pileLabel = pile[labelType].toFixed(2);
        pileLabel = pileLabel.replace(".",",");

      }else{
        pileLabel = pile[labelType];
      }
      let textGeometry = createGeometry({
        font: loadedFont,
        text: pileLabel
      });

      let zPos = (typeg === "2d") ? 10.0 :  parseFloat(pile.z_col);
      let vertexAttribute = textGeometry.getAttribute('position');

      let newVertPosArray;
      if(typeg === "2d") {
       newVertPosArray = modifyVertexArray2D(vertexAttribute.array, zPos);
      }
      else {
        newVertPosArray = modifyVertexArray3D(vertexAttribute.array, zPos);
      }

      // get size data (height depends only on font size)
      textGeometry.setAttribute( 'position', new BufferAttribute( newVertPosArray, 3 ) );
      let textObject = new Mesh(textGeometry);
      return { sprite: textObject };
    }

    function updateProject() {

      if(currentDimension === "2d") {
        clearTimeout(updateTimer);

        let url = new URLSearchParams(window.location.search);

        let parameters = {
          projectID: url.get('PROJEKT_ID'),
          userID: url.get('USER_ID'),
          type: url.get('type')
        };

        let data = {
          rotation: gridRotY,
          gridX: gridX,
          gridY: gridY,
          zoom: camera.zoom,
          x: camera.position.x,
          y: camera.position.y,
          z: camera.position.z,
          label: labelType,
          filter1: filterType1,
          filter2: filterType2,
        };
        if (data.gridX !== oldData.gridX || data.gridY !== oldData.gridY || data.rotation !== oldData.rotation) {
          oldData.gridX = data.gridX;
          oldData.gridY = data.gridY;
          oldData.rotation = data.rotation;

          jQuery.ajax("updateGridPosition.php", {
            async: false,
            data: {
              projectID: parameters.projectID,
              gridX: data.gridX,
              gridY: data.gridY,
              rotation: data.rotation,

            }
          });

          // getPiles();
        }
        if (
            (data.rotation !== oldData.rotation && rotateBool === false) ||
            data.zoom !== oldData.zoom ||
            data.x !== oldData.x ||
            data.y !== oldData.y ||
            data.z !== oldData.z ||
            data.label !== oldData.label ||
            data.filter1 !== oldData.filter1 ||
            data.filter2 !== oldData.filter2
        ) {
          oldData.rotation = data.rotation;
          oldData.zoom = data.zoom;
          oldData.x = data.x;
          oldData.y = data.y;
          oldData.z = data.z;
          oldData.label = data.label;
          oldData.filter1 = data.filter1;
          oldData.filter2 = data.filter2;
          jQuery.ajax("updatePreferences.php",
              { async: false,
                data: {
                  projectID: parameters.projectID,
                  userID: parameters.userID,
                  type: parameters.type,
                  rotation: data.rotation, // This is gridrotation, should be updated to camerarotation in the future if we start using it
                  zoom: data.zoom,
                  x: data.x,
                  y: data.y,
                  z: data.z,
                  label: data.label,
                  filter1: data.filter1,
                  filter2: data.filter2,
                  target_z: data.target_z,
                },
              });

        }

        updateTimer = setTimeout(updateProject, 2000);
      }

    } //End of update project

  }
}

function loadFontAndInitializeApp() {
  // font genereated at https://msdf-bmfont.donmccurdy.com/
  loadFont('fonts/ISOCPEUR-msdf.json', function(err, loadedFont) {
    let textureLoader = new TextureLoader();
    textureLoader.load('fonts/ISOCPEUR.png', function (loadedTexture) {
      let textMaterial2D = new RawShaderMaterial(
          MSDFShader2D({
            map: loadedTexture,
            color: 0x000000,
            side: FrontSide,
            depthTest: false,
            transparent: true,
            negate: false
          })
      );

      let textMaterial3D = new RawShaderMaterial(
          MSDFShader3D({
            map: loadedTexture,
            color: 0x000000,
            side: DoubleSide,
            depthTest: false,
            transparent: true,
            negate: false
          })
      );

      rootTextTexture = loadedTexture;
      propileDrawingApp = new PropileDrawingApp(loadedFont, loadedTexture, textMaterial2D, textMaterial3D)
    });
  });
}


window.onload = function() {

  function resetPropileApp() {
    if(rootScene){

      rootScene.traverse(obj => {
        if (obj instanceof  Mesh) {
          obj.geometry.dispose();
          obj.material.dispose();
        }
      });
    }
    rootTextTexture.dispose();
    rendererCanvas.dispose();

    rootScene = null;
    rootTextTexture = null;
    rendererCanvas = null;
    propileDrawingApp = null;
    let type = "";

    //Cancel old requestAnimationFrame
    if(reqAnimFrameId !== null){
      cancelAnimationFrame(reqAnimFrameId);
      reqAnimFrameId = null;
    }

    if (document.querySelector("#pile-type-btg-or-steel")) {
      type = document.querySelector("#pile-type-btg-or-steel").value;
      type = type.charAt(0).toUpperCase() + type.slice(1);
    }
    //remove event listeners.
    let oldPileMap = document.getElementsByClassName("pileMapContainer"+type)[0];
    let newPileMap = oldPileMap.cloneNode(true);
    oldPileMap.parentNode.replaceChild(newPileMap, oldPileMap);

    //Re-add the click event listener
    $('.toggleDrawingBtg').click(toggleDrawing);
    $('.toggleDrawingSteel').click(toggleDrawing);

    // reset textscaling input
    $('.textScaler').val('1');
    $('.pileMapTextScale').text('x1');
  }

  function toggleDrawing(event) {
    resetPropileApp();

    if(currentDimension === "2d"){
      //Switch to 3d
      $(".toggleDrawingBtg").val("2d");
      $(".toggleDrawingSteel").val("2d");
      $('.toggleDrawingBtg').click(toggleDrawing);
      $('.toggleDrawingSteel').click(toggleDrawing);
      $( "#project_bearing_steel_form" ).attr('hidden',true);
      $( "#submit_project_bearing_steel" ).attr('hidden',true);
      $( "#project_bearing_btg_form" ).attr('hidden',true);
      $( "#submit_project_bearing_btg" ).attr('hidden',true);
      currentDimension = "3d";

    }
    else {//Switch to 2d
      $(".toggleDrawingBtg").val("3d");
      $(".toggleDrawingSteel").val("3d");

      currentDimension = "2d";
      $('.toggleDrawingBtg').click(toggleDrawing);
      $('.toggleDrawingSteel').click(toggleDrawing);
      $( "#project_bearing_steel_form" ).attr('hidden',false);
      $( "#submit_project_bearing_steel" ).attr('hidden',false);
      $( "#project_bearing_btg_form" ).attr('hidden',false);
      $( "#submit_project_bearing_btg" ).attr('hidden',false);
    }
    loadFontAndInitializeApp();
  }

  function clearThreeCanvas(){
    // clear canvas
    while(rootScene.children.length > 0){
      rootScene.remove(rootScene.children[0]);
    }
    //Cancel old requestAnimationFrame
    if(reqAnimFrameId !== null){
      cancelAnimationFrame(reqAnimFrameId);
      reqAnimFrameId = null;
    }
    // set default 2d
    $(".toggleDrawingBtg").val("3d");
    $(".toggleDrawingSteel").val("3d");
    currentDimension = "3d";
  }


  //Load 2d by default.
  currentDimension = "3d";
  loadFontAndInitializeApp();

  //Add an event listener for toggle.
  $('.toggleDrawingBtg').click(toggleDrawing);
  $('.toggleDrawingSteel').click(toggleDrawing);
  $('.not-pilemap').click(clearThreeCanvas);

  $( "#project_bearing_steel_form" ).attr('hidden',false);
  $( "#submit_project_bearing_steel" ).attr('hidden',false);
  $( "#project_bearing_btg_form" ).attr('hidden',false);
  $( "#submit_project_bearing_btg" ).attr('hidden',false);

}
